const mediaItems = [
  {
    title: '《星际迷航：新纪元》定档预告',
    desc: '年度科幻巨制正式定档，震撼特效与宏大叙事交织，带你穿越浩瀚星海。抢先一睹未来世界的视觉奇观。',
    date: '2026-07-30',
    tag: '科幻大片',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20space%20scene%20with%20futuristic%20spaceship%20and%20nebula%20galaxy%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20movie%20poster%20style%2C%20warm%20and%20cool%20tone%20contrast%2C%20professional%20film%20photography%20aesthetic&width=800&height=500&seq=media-sci-fi-01&orientation=landscape',
  },
  {
    title: '《长安十二时辰》第二季先导片',
    desc: '盛唐风云再起，原班人马倾力打造。古装悬疑巅峰回归，精良制作再现大唐风华。',
    date: '2026-07-29',
    tag: '古装悬疑',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20dusk%20with%20lanterns%20and%20traditional%20architecture%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20golden%20tones%2C%20film-like%20composition%2C%20epic%20historical%20drama%20aesthetic&width=800&height=500&seq=media-historical-02&orientation=landscape',
  },
  {
    title: '《深海奇缘》动画电影精彩片段',
    desc: '国产动画巅峰之作，每一帧都是壁纸。讲述深海世界奇幻冒险，治愈系故事感动千万观众。',
    date: '2026-07-28',
    tag: '动画电影',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20underwater%20animated%20scene%20with%20colorful%20coral%20reef%20and%20magical%20sea%20creatures%2C%20soft%20ethereal%20lighting%2C%20dreamy%20atmosphere%2C%20vibrant%20warm%20colors%2C%20artistic%20animation%20style%2C%20cinematic%20composition&width=800&height=500&seq=media-animation-03&orientation=landscape',
  },
  {
    title: '《极限挑战》第十季幕后花絮',
    desc: '笑料百出的幕后故事首次曝光，六位MC私下互动超有爱。欢乐与感动并存的热门综艺。',
    date: '2026-07-27',
    tag: '热门综艺',
    img: 'https://readdy.ai/api/search-image?query=Fun%20and%20energetic%20variety%20show%20studio%20set%20with%20colorful%20lighting%20and%20stage%20design%2C%20entertaining%20atmosphere%2C%20warm%20vibrant%20tones%2C%20professional%20TV%20production%20photography%2C%20lively%20composition&width=800&height=500&seq=media-variety-04&orientation=landscape',
  },
  {
    title: '《地球脉动》纪录片独家专访',
    desc: '主创团队讲述拍摄背后的震撼故事，历时5年走遍全球取景。自然与人文交织的视觉盛宴。',
    date: '2026-07-26',
    tag: '纪录片',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20nature%20landscape%20with%20mountains%20and%20golden%20sunset%2C%20documentary%20film%20aesthetic%2C%20breathtaking%20natural%20scenery%2C%20warm%20earthy%20tones%2C%20professional%20wildlife%20photography%20style%2C%20epic%20cinematic%20composition&width=800&height=500&seq=media-nature-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            精彩预告
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            抢先预览 · 精彩不容错过
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer ${
                i >= 3 ? 'lg:col-span-1' : ''
              } ${i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-48 md:h-56 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium bg-accent-500 text-background-50 mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="block text-xs text-background-50/70">{item.date}</span>
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-2xl"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-foreground-900 text-base mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}